import { useQueryClient } from "@tanstack/react-query"
import { botBuilderKeys, type CustomBot } from "@/entities/bot-builder"
import { useSessionRole } from "@/entities/session"
import { BotPaymentsCard } from "@/features/manage-bot-payments"
import { AccessDenied } from "@/shared/ui/access-denied"
import { useBotWorkspace, WorkspaceSection } from "@/widgets/bot-workspace"

/** «Настройки бота → Платёжные сервисы»: ЮKassa через Telegram Payments и список платежей. */
export function PaymentsPage() {
	const { bot } = useBotWorkspace()
	const { isAdmin } = useSessionRole()
	const queryClient = useQueryClient()
	const applyBot = async (next: CustomBot) => {
		queryClient.setQueryData(botBuilderKeys.bot(next.id), next)
		await queryClient.invalidateQueries({ queryKey: botBuilderKeys.bots })
	}
	if (!isAdmin) return <AccessDenied title="Платёжные сервисы" />

	return (
		<WorkspaceSection
			title="Платёжные сервисы"
			subtitle="Оплата прямо в Telegram через ЮKassa: токен из @BotFather → Payments. Блок «Счёт на оплату» в воронках."
		>
			<BotPaymentsCard bot={bot} onBotChange={applyBot} />
		</WorkspaceSection>
	)
}
